import CapacityElectricityDTO from 'features/contracts/dtos/CapacityElectricityDTO';
import PageCard from 'features/shared/components/card/PageCard';
import NoContentWrapper from 'features/shared/components/noContentWrapper/NoContentWrapper';
import React from 'react';
import ReservedCapacityElectricity from 'features/contracts/components/reservedCapacity/ReservedCapacityElectricity';
import ReservedCapacityElectricityHeader from 'features/contracts/components/reservedCapacity/ReservedCapacityElectricityHeader';
import { ReservedCapacityFormSection_PageCard } from 'features/shared/components/loaders/promiseLoadingAreas';
import { useTranslation } from 'react-i18next';

interface Props {
  bindField: any;
  capacities: CapacityElectricityDTO[];
  onCapacityInputBlur: (e: React.FocusEvent<HTMLInputElement>, capacity: CapacityElectricityDTO) => void;
  editable: boolean;
  selectedMonth?: number;
  errors?: Record<string, string>;
}

const ReservedCapacitySubForm = ({bindField,  capacities, onCapacityInputBlur, editable, selectedMonth, errors }: Props) => {
  //#region translations
  const tLabels = useTranslation("requirements\\requirements").t;
  //#endregion translations

  //#region  helpers
  const isInputDisabled = (selectedMonth?: number, month?: number): boolean => {
    if (selectedMonth && month) {
      return month < selectedMonth;
    }

    return true;
  }

  const getInputName = (month: number): string => {
    let monthFull = month < 10 ? `0${month}` : String(month);   
    return `DESC_TMZMSMLEEKAP${monthFull}`;
  }

  const getError = (month: number): string | undefined => {
    if (errors) {
      let inputName = getInputName(month);
      return errors[inputName] ? errors[inputName] : undefined;  
    }
  }
  //#endregion helpers

  
  //#region sub-renders
  const renderCapacities = () => {
    const count = capacities.length;

    return capacities.map((item, index) => (
      <div className="py-1" key={index}>
        <ReservedCapacityElectricity
          capacity={item}
          bindField={bindField}
          onBlur={onCapacityInputBlur}
          inputName={getInputName(item.month!)}
          disabledInput={isInputDisabled(selectedMonth, item.month)}
          error={getError(item.month!)}
        />
        {renderDivider(count, index)}
      </div>
    ));
  }

  const renderDivider = (count: number, index: number) => {
    if (index < count - 1) {
      return <hr className="d-sm-none mb-2"/>;
    }
  }
  //#endregion sub-renders

  //#region  render
  if (editable) {
    return (
      <PageCard 
        title={tLabels("reservedCapacitySubForm.cardTitle")}
        subtitle="[MW]" 
        bodyClassName="p-4"
        loadingAreaName={ReservedCapacityFormSection_PageCard}
        loadingDelay={0}
      >
        <NoContentWrapper 
          data={capacities}
          loadStatus="AfterFirstLoad"
          noContentRender={() => <div className="text-muted">{tLabels("reservedCapacitySubForm.message")}</div>}
        >
          <ReservedCapacityElectricityHeader requirementView />
          {renderCapacities()}
        </NoContentWrapper>
      </PageCard>
    );
  } else {
    return null;
  }
}
//#endregion  render

export default ReservedCapacitySubForm;
